import { render, staticRenderFns } from "./ZyroCollapse.vue?vue&type=template&id=80d6cf9e&scoped=true&"
import script from "./ZyroCollapse.vue?vue&type=script&lang=js&"
export * from "./ZyroCollapse.vue?vue&type=script&lang=js&"
import style0 from "./ZyroCollapse.vue?vue&type=style&index=0&id=80d6cf9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d6cf9e",
  null
  
)

export default component.exports